import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ValidityDatas } from '../validity-datas';
import { ValidityEditorComponent } from '../validity-editor/validity-editor.component';

@Component({
  selector: 'atm-validity-detail',
  templateUrl: './validity-detail.component.html',
  styleUrls: ['./validity-detail.component.scss'],
})
export class ValidityDetailComponent implements OnInit, OnChanges {
  @Input() validity?: string;
  @Input() validityTz?: string;
  @Input() actions?: boolean = true;
  @Input() fullSettings?: boolean = false;
  @Input() tinySettings?: boolean = false;
  @Output() settedValidity = new EventEmitter<{
    validity: string;
    validityTz: string;
  }>();
  status = 'highlight_off pause_circle_outline play_circle_outline';
  isUpdate = false;
  @Input() validityData!: ValidityDatas;

  editStart = false;
  editStartDate: Date | null = null;
  editEndDate: Date | null = null;

  showCalendar = {
    start: false,
    end: false,
  };

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
    if (!this.validityData) {
      this.validityData = new ValidityDatas(this.validity, this.validityTz);
    }
    this.status = this.setStatus(
      this.validityData.start?.timestamp,
      this.validityData.end?.timestamp
    );
    this.isUpdate = !!this.validityData.start;
  }

  ngOnChanges(): void {
    this.validityData = new ValidityDatas(this.validity, this.validityTz);
    this.status = this.setStatus(
      this.validityData.start?.timestamp,
      this.validityData.end?.timestamp
    );
    this.isUpdate = !!this.validityData.start;
  }

  setValidity() {
    const validityDialog = this.dialog.open(ValidityEditorComponent, {
      data: this.validityData,
      maxHeight: '90vh',
      maxWidth: '90vh',
      width: '750px',
    });
    validityDialog.afterClosed().subscribe((validity: ValidityDatas) => {
      if (validity) {
        this.validityData = validity;
        this.isUpdate = true;
        this.settedValidity.emit({
          validity: validity.toString(),
          validityTz: validity.timezone?.value!,
        });
      }
    });
  }

  changeValidityDate(start: boolean) {
    this.settedValidity.emit({
      validity: this.validityData.toString(),
      validityTz: this.validityData.timezone?.value!,
    });
    this.status = this.setStatus(
      this.validityData.start?.timestamp,
      this.validityData.end?.timestamp
    );
    this.showHideCalendar(start);
  }

  showHideCalendar(start: boolean) {
    if (start) {
      this.showCalendar.start = !this.showCalendar.start;
      this.showCalendar.end = false;
    } else {
      this.showCalendar.end = !this.showCalendar.end;
      this.showCalendar.start = false;
    }
  }

  setStartDate() {}

  private setStatus(
    start: number | undefined,
    end: number | undefined
  ): string {
    const now = Date.now();
    if (!start && !end) {
      return 'all_inclusive';
    }
    if (!start) {
      return end && now < end ? 'play_circle_filled_white' : 'pause';
    }
    if (!end) {
      return start && now > start ? 'play_circle_filled_white' : 'schedule';
    }
    if (now > start) {
      return now < end ? 'play_circle_filled_white' : 'pause';
    }
    return 'schedule';
  }

  getMonth(value: number) {
    return new Date(2000, value, 10);
  }
}
